import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function InvitationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section id="invitation" className="relative py-24 md:py-36 bg-midnight overflow-hidden">
      {/* Cinematic side light */}
      <div className="absolute top-0 left-1/4 w-[1px] h-full bg-gradient-to-b from-transparent via-copper/10 to-transparent pointer-events-none" />
      <div className="absolute top-0 right-1/4 w-[1px] h-full bg-gradient-to-b from-transparent via-copper/10 to-transparent pointer-events-none" />

      <div className="max-w-3xl mx-auto px-6" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
          className="relative bg-ink-light/30 backdrop-blur-sm rounded-3xl p-10 md:p-16 border border-copper/8"
        >
          {/* Decorative corner brackets */}
          <div className="absolute top-6 left-6 w-10 h-10 border-t-2 border-l-2 border-copper/15 rounded-tl-xl" />
          <div className="absolute top-6 right-6 w-10 h-10 border-t-2 border-r-2 border-copper/15 rounded-tr-xl" />
          <div className="absolute bottom-6 left-6 w-10 h-10 border-b-2 border-l-2 border-copper/15 rounded-bl-xl" />
          <div className="absolute bottom-6 right-6 w-10 h-10 border-b-2 border-r-2 border-copper/15 rounded-br-xl" />

          {/* Large decorative quotes */}
          <span className="absolute top-8 left-10 font-display text-[100px] md:text-[140px] text-copper/8 leading-none select-none">
            &ldquo;
          </span>
          <span className="absolute bottom-4 right-10 font-display text-[100px] md:text-[140px] text-copper/8 leading-none select-none rotate-180">
            &ldquo;
          </span>

          <div className="relative z-10 text-center">
            <p className="font-sans text-xs uppercase tracking-[3px] text-copper/50 mb-8">
              Invitation
            </p>

            <div className="font-serif text-lg md:text-xl lg:text-2xl text-cream/90 leading-[1.8] md:leading-[2] space-y-6">
              <p>
                <span className="font-semibold text-cream">
                  Mr. Abdul Majeed &amp; Mrs. Zeenath
                </span>
                <br />
                <span className="text-pearl/60 italic font-normal text-base md:text-lg">
                  Chakkungal (H), Muvattupuzha
                </span>
              </p>

              <p className="text-cream/40 italic font-normal text-base">and</p>

              <p>
                <span className="font-semibold text-cream">
                  Mr. Shekkeer Ali &amp; Mrs. Raseena
                </span>
                <br />
                <span className="text-pearl/60 italic font-normal text-base md:text-lg">
                  Thachiyath (H), Kothamangalam
                </span>
              </p>

              <p className="text-base md:text-lg text-pearl/70 italic">
                request the pleasure of your company at the auspicious occasion of the marriage of their children
              </p>

              <p className="font-display text-xl md:text-2xl text-copper-light font-semibold">
                Sharoof C Majeed
              </p>

              <p className="text-cream/50">with</p>

              <p className="font-display text-xl md:text-2xl text-copper-light font-semibold">
                Adhabiya Shekkeer Ali
              </p>
            </div>

            <div className="flex items-center justify-center gap-3 mt-10">
              <span className="w-12 h-px bg-copper/20" />
              <i className="ri-heart-3-fill text-copper/30 w-4 h-4 flex items-center justify-center" />
              <span className="w-12 h-px bg-copper/20" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}